import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { FC } from 'react';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { SxProps, Theme } from '@mui/material';
import { TDatePickerComponentProps } from './types';
import { EDatePickerAllowedRange } from './constants';

export const DatePickerComponent: FC<TDatePickerComponentProps> = ({
	value,
	onChange,
	label,
	id,
	disabled = false,
	sx = { marginTop: '16px' },
	allowedRange = EDatePickerAllowedRange.ALL,
}) => {
	return (
		<LocalizationProvider dateAdapter={AdapterLuxon}>
			<DemoContainer components={['DatePicker']}>
				<DatePicker
					format="yyyy-MM-dd"
					value={value}
					onAccept={(newValue) => {
						onChange(newValue);
					}}
					onChange={() => true}
					label={label}
					sx={{
						width: '100%',
						minWidth: '100%',
						...sx,
					}}
					slotProps={{ textField: { size: 'small' } }}
					disabled={disabled}
					disablePast={allowedRange === EDatePickerAllowedRange.FUTURE}
					disableFuture={allowedRange === EDatePickerAllowedRange.PAST}
				/>
			</DemoContainer>
		</LocalizationProvider>
	);
};
